import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/api/auth/login',
    method: 'post',
    data
  }).then(res => res)  // 返回 token 字符串
}

export function switchFactory(data) {
  return request({
    url: '/api/auth/switch-factory',
    method: 'post',
    data
  })
}




export function getCaptcha() {
  return request({
    url: '/api/auth/captcha',
    method: 'get'
  })
}

// ... 其他